import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=4fcd5510&scoped=true&"
import script from "./Filters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Filters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=4fcd5510&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd5510",
  null
  
)

export default component.exports